import { Box, Flex, Icon, Text } from "@chakra-ui/react";
import type { NavItem } from "./navConfig";
import { useNavLabel } from "./useNavLabel";

interface Props {
  item: NavItem;
  isActive: boolean;
  badge?: number;
  onClick: () => void;
}

export const SidebarNavItem = ({ item, isActive, badge, onClick }: Props) => {
  const navLabel = useNavLabel();

  return (
    <Flex
      as="button"
      type="button"
      onClick={onClick}
      align="center"
      gap="3"
      w="full"
      px="3"
      py="2"
      mb="0.5"
      rounded="lg"
      textAlign="left"
      transition="background-color 0.15s, color 0.15s"
      bg={isActive ? "smPrimarySofter" : "transparent"}
      color={isActive ? "smPrimary" : "smMuted"}
      fontWeight={isActive ? "medium" : "normal"}
      fontSize="sm"
      _hover={{ bg: isActive ? "smPrimarySofter" : "smBackgroundSecondary" }}
    >
      <Icon as={item.icon} boxSize="18px" flexShrink={0} />
      <Text flex="1" isTruncated>
        {navLabel(item.labelKey)}
      </Text>
      {badge != null && badge > 0 && (
        <Box
          flexShrink={0}
          minW="20px"
          h="20px"
          px="1.5"
          rounded="full"
          fontSize="11px"
          fontWeight="semibold"
          lineHeight="20px"
          textAlign="center"
          bg={isActive ? "smPrimary" : "smBackgroundTertiary"}
          color={isActive ? "white" : "smText"}
        >
          {badge}
        </Box>
      )}
    </Flex>
  );
};
